import { mapper, salt } from './hashMap'
var data = require('./addressData.js')

export function changeOrderStatusToThaiLanguage(status) {
    if (status == "Approved") return "ชำระเงินแล้ว";
    else if (status == "Sent") return "จัดส่งแล้ว";
    else if (status == "Shopping") return "กำลังหยิบสินค้า";
    else if (status == "Pending") return "รอการชำระเงิน";
    else if (status == "Packaging") return "รอการจัดส่ง";
    else if (status == "Cancel") return "ยกเลิกการสั่งซื้อ";
    else if (status == "CheckingPrice") return "กำลังเช็คราคา"
    else if (status == "Queuing") return "กำลังรอคิว"
    else if (status == "Reject") return "ลูกค้าปฏิเสธ"
    else if (status == "Checkorderrequest") return "รอการตรวจสอบข้อมูล"
    else if (status == "PaymentDenied") return "ปฏิเสธการตัดบัตรเครดิต"
    else return "มีปัญหา";
}
export function getMoneyFormat(old) {
    old = old + "";
    return (old) ? old.replace(/(\d)(?=(\d{3})+\.)/g, "$1,") : "";
}
export function getThaiBahtString(Number) {
    for (var i = 0; i < Number.length; i++) {
        Number = Number.replace(",", "");
        Number = Number.replace(" ", "");
        Number = Number.replace("บาท", "");
        Number = Number.replace("฿", "");
    }
    var TxtNumArr = new Array("ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
    var TxtDigitArr = new Array("", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน");
    var BahtText = "";
    if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
    } else {
        if ((Number - 0) > 9999999.9999) {
            return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
            Number = Number.split(".");
            if (Number[1].length > 0) {
                Number[1] = Number[1].substring(0, 2);
            }
            var NumberLen = Number[0].length - 0;
            for (var i = 0; i < NumberLen; i++) {
                var tmp = Number[0].substring(i, i + 1) - 0;
                if (tmp != 0) {
                    if ((i == (NumberLen - 1)) && (tmp == 1)) {
                        BahtText += "เอ็ด";
                    } else
                        if ((i == (NumberLen - 2)) && (tmp == 2)) {
                            BahtText += "ยี่";
                        } else
                            if ((i == (NumberLen - 2)) && (tmp == 1)) {
                                BahtText += "";
                            } else {
                                BahtText += TxtNumArr[tmp];
                            }
                    BahtText += TxtDigitArr[NumberLen - i - 1];
                }
            }
            BahtText += "บาท";
            if ((Number[1] == "0") || (Number[1] == "00")) {
                BahtText += "ถ้วน";
            } else {
                var DecimalLen = Number[1].length - 0;
                for (var i = 0; i < DecimalLen; i++) {
                    var tmp = Number[1].substring(i, i + 1) - 0;
                    if (tmp != 0) {
                        if ((i == (DecimalLen - 1)) && (tmp == 1)) {
                            BahtText += "เอ็ด";
                        } else
                            if ((i == (DecimalLen - 2)) && (tmp == 2)) {
                                BahtText += "ยี่";
                            } else
                                if ((i == (DecimalLen - 2)) && (tmp == 1)) {
                                    BahtText += "";
                                } else {
                                    BahtText += TxtNumArr[tmp];
                                }
                        BahtText += TxtDigitArr[DecimalLen - i - 1];
                    }
                }
                BahtText += "สตางค์";
            }
            return BahtText;
        }
    }
}
export function cuttingLongText(text) {
    if (text === undefined) {
        return ''
    }
    return text.length > 15 ? text.substr(0, 15) + '...' : text
}
export function cuttingLongNameText(text) {
    if (text === undefined) {
        return ''
    }
    return text.length > 10 ? text.substr(0, 10) + '...' : text
}
export function getBlogDescriptionString(text, length) {
    if (text === undefined) {
        return ''
    }
    return text.length > length ? text.substr(0, length) + '...' : text
}
export function getDateString(timestamp) {
    var date = new Date(Number(timestamp))
    let datee = date.getDate()
    datee < 10 ? datee = '0' + datee : ''
    let month = date.getMonth() + 1
    month < 10 ? month = '0' + month : ''
    return (datee + "/" + month + "/" + (date.getFullYear() + 543))
}
export function getShortDateString(timestamp) {
    var date = new Date(Number(timestamp))
    return (date.getDate() + "-" + (date.getMonth() + 1) + "-" + (date.getFullYear() + 543))
}
export function getTimeStringForShop(timestamp) {
    var date = new Date(Number(timestamp))
    var year = date.getFullYear() + 543
    var shortyear = year.toString().substring(2)
    var currentMonth = date.getMonth() + 1
    if (currentMonth < 10) { currentMonth = '0' + currentMonth }
    var currentDate = date.getDate()
    if (currentDate < 10) { currentDate = '0' + currentDate }
    return ((shortyear) + "" + (currentMonth) + "" + (currentDate))
}
export function getRealAmount(store_cost, store_cost_unit) {
    return Number((store_cost / store_cost_unit).toFixed(2))
}
export function getRealStoreCostUnit(store_cost, amount) {
    return Number((store_cost / amount).toFixed(2))
}
export function getQueryStringParams(queryString) {
    var obj = {}
    queryString = queryString.replace('?', '')
    var params = queryString.split('&')
    params.forEach(function (param) {
        var p = param.split('=')
        obj[p[0]] = p[1]
    }, this);
    return obj
}
export function getFullDateString(time) {
    let datee = new Date(Number(time))
    let date = datee.getDate()
    let month = datee.getMonth()
    let year = datee.getFullYear() + 543
    if (date < 10) {
        date = '0' + date
    }
    switch (month) {
        case 0: month = 'มกราคม'
            break
        case 1: month = 'กุมภาพันธ์'
            break
        case 2: month = 'มีนาคม'
            break
        case 3: month = 'เมษายน'
            break
        case 4: month = 'พฤษภาคม'
            break
        case 5: month = 'มิถุนายน'
            break
        case 6: month = 'กรกฎาคม'
            break
        case 7: month = 'สิงหาคม'
            break
        case 8: month = 'กันยายน'
            break
        case 9: month = 'ตุลาคม'
            break
        case 10: month = 'พฤษจิกายน'
            break
        case 11: month = 'ธันวาคม'
            break
    }
    return (date + ' ' + month + ' ' + year)
}
export function getDateDeliveryTimeEven(time, tmr) {
    let datee = new Date(time)
    let date_tmr = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    let date = datee.getDate()
    tmr ? date = date_tmr.getDate() : ''
    let month = datee.getMonth()
    tmr ? month = date_tmr.getMonth() : ''
    if (date < 10) {
        date = '0' + date
    }
    switch (month) {
        case 0: month = 'ม.ค.'
            break
        case 1: month = 'ก.พ.'
            break
        case 2: month = 'มี.ค.'
            break
        case 3: month = 'เม.ย.'
            break
        case 4: month = 'พ.ค.'
            break
        case 5: month = 'มิ.ย.'
            break
        case 6: month = 'ก.ค.'
            break
        case 7: month = 'ส.ค.'
            break
        case 8: month = 'ก.ย.'
            break
        case 9: month = 'ต.ค.'
            break
        case 10: month = 'พ.ย.'
            break
        case 11: month = 'ธ.ค.'
            break
    }
    return ('('+ date +'-'+ month+') ')
}
export function getDateDeliveryTime(time, tmr) {
    let datee = new Date(time)
    let date_tmr = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    let date = datee.getDate()
    tmr ? date = date_tmr.getDate() : ''
    let month = datee.getMonth()
    tmr ? month = date_tmr.getMonth() : ''
    if (date < 10) {
        date = '0' + date
    }
    switch (month) {
        case 0: month = 'ม.ค.'
            break
        case 1: month = 'ก.พ.'
            break
        case 2: month = 'มี.ค.'
            break
        case 3: month = 'เม.ย.'
            break
        case 4: month = 'พ.ค.'
            break
        case 5: month = 'มิ.ย.'
            break
        case 6: month = 'ก.ค.'
            break
        case 7: month = 'ส.ค.'
            break
        case 8: month = 'ก.ย.'
            break
        case 9: month = 'ต.ค.'
            break
        case 10: month = 'พ.ย.'
            break
        case 11: month = 'ธ.ค.'
            break
    }
    return (' ( ' + date + ' ' + month + ' ) ')
}
export function getTimeString(timestamp) {
    var date = new Date(Number(timestamp))
    var hours = date.getHours()
    var min = date.getMinutes()
    if (min < 10) {
        min = '0' + min
    }
    if (hours < 10) {
        hours = '0' + hours
    }
    return (hours + ':' + min)
}
export function compareTimestampIsSameDay(t1, t2) {
    var d1 = new Date(t1).setHours(0, 0, 0, 0)
    var d2 = new Date(t2).setHours(0, 0, 0, 0)
    return d1 === d2
}

export function getAddressData() {
    return decode(data)
}

function decode(data) {
    var lookup = [],
        words = [],
        expanded = [],
        t;

    if (data.data.lookup && data.data.words) {
        // compact with dictionary and lookup
        lookup = data.data.lookup.split('|');
        words = data.data.words.split('|');
        data = data.data;
    }

    t = function (text) {
        function repl(m) {
            var ch = m.charCodeAt(0);
            return words[ch < 97 ? ch - 65 : 26 + ch - 97];
        }
        if (typeof text === 'number') {
            text = lookup[text];
        }
        return text.replace(/[A-Z]/ig, repl);
    };
    data.data.map(provinces => {
        var i = 1;
        provinces[i].map(function (amphoes) {
            amphoes[i].map(function (districts) {
                districts[i] = districts[i] instanceof Array ? districts[i] : [districts[i]];
                districts[i].map(function (zipcode) {
                    var entry = {
                        district: t(districts[0]),
                        amphoe: t(amphoes[0]),
                        province: t(provinces[0]),
                        zipcode: zipcode
                    };
                    expanded.push(entry);
                });
            });
        });
    });
    return expanded;
}

export function santipapHashing(number) {
    var result = ''
    number = String(Number(number) + salt)
    for (var i = 0; i < number.length; i++) {
        result += mapper[(number.charAt(i))]
    }
    return result
}

export function regexNumber(value) {
    var reg = /^\d+$/;
    return reg.test(value)
}

export function isArrayEqual(array1, array2) {
    let bool = true
    if (array1.length !== array2.length) {
        bool = false
    }
    array1.forEach((element, index) => {
        if (element !== array2[index]) {
            bool = false
        }
    })
    return bool
}


// WEBPACK FOOTER //
// ./src/utils.js